import React from 'react';
import '../react-adaptive-hooks/hardware-concurrency/index.js';
import { useMemoryStatus } from '../react-adaptive-hooks/memory/index.js';
import { useNetworkStatus } from '../react-adaptive-hooks/network/index.js';
import { useSaveData } from '../react-adaptive-hooks/save-data/index.js';
import ClientHintsContext from './ClientHintsContext.js';

const saveDataDefault = false;
const effectiveConnectionTypeDefault = '4g';
const ClientHintsProvider = ({ saveData, effectiveConnectionType, deviceMemory, children }) => {
    const { saveData: saveDataSignal } = useSaveData(saveData);
    const { effectiveConnectionType: effectiveConnectionTypeSignal } = useNetworkStatus(effectiveConnectionType);
    const { deviceMemory: memorySignal } = useMemoryStatus({ deviceMemory });
    return (React.createElement(ClientHintsContext.Provider, { value: {
            saveData: saveDataSignal ?? saveDataDefault,
            effectiveConnectionType: effectiveConnectionTypeSignal ?? effectiveConnectionTypeDefault,
            deviceMemory: memorySignal,
        } }, children));
};

export { ClientHintsProvider as default };
//# sourceMappingURL=ClientHintsProvider.js.map
